import {getPrimaryColor} from 'utils/cache'

const home = {
  state: {
    primaryColor: getPrimaryColor() ? getPrimaryColor() : '#1c1c1c',
    sliderBarActiveIndex: '1-1',
    sliderBarState: true,
    minHeight: ''
  },
  mutations: {
    SET_SLIDERBARACTIVEINDEX (state, res) {
      state.sliderBarActiveIndex = res
    },
    SET_PRIMARY (state, res) {
      state.primaryColor = res
    },
    TOGGLE_SLIDERBARSTATE (state) {
      state.sliderBarState = !state.sliderBarState
    },
    SET_MINHEIGHT (state, height) {
      state.minHeight = height
    }
  },
  actions: {
    getPrimary ({commit}, color) {
      commit('SET_PRIMARY', color)
    },
    getMinHeight ({commit}, height) {
      commit('SET_MINHEIGHT', height)
    },
    getSliderBarActiveIndex ({commit}, index) {
      commit('SET_SLIDERBARACTIVEINDEX', index)
    },
    toggleSliderBarState ({commit}) {
      commit('TOGGLE_SLIDERBARSTATE')
    }
  }
}
export default home



// WEBPACK FOOTER //
// ./src/store/modules/home.js